
import { Link } from "react-router-dom";
import { User } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/hooks/useAuth";

export function UserDropdown() {
  const { user, signOut, isAdmin } = useAuth();

  const handleSignOut = async () => {
    await signOut();
  };

  const getDashboardUrl = () => {
    return isAdmin ? "/logins?admin=true" : "/meus-dados";
  };

  if (!user) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center justify-center w-10 h-10 rounded-full bg-brand-primary/10 hover:bg-brand-primary/20 transition-colors text-brand-primary">
        <User size={20} />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-48 bg-white z-50">
        <DropdownMenuItem>
          <Link to={getDashboardUrl()} className="w-full">
            Painel
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem>
          <Link to="/meus-dados" className="w-full">
            Meus Dados
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem>
          <Link to="/preferencias" className="w-full">
            Preferências
          </Link>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleSignOut}>
          Sair
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
